import { useQuery } from "@tanstack/react-query";
import { sharedQuery, workspacesQuery, type Workspace } from "./data.ts";

/**
 * The workspace being viewed: one the viewer belongs to, or, for a reader outside it, one where
 * pages were shared with them (role null). Undefined while loading, or when neither applies.
 */
export function useWorkspace(workspaceId: string): {
  workspace: Workspace | undefined;
  loaded: boolean;
} {
  const workspaces = useQuery(workspacesQuery);
  const member = workspaces.data?.find((w) => w.id === workspaceId);
  const shared = useQuery({ ...sharedQuery, enabled: workspaces.isSuccess && !member });
  const page = shared.data?.find((p) => p.workspaceId === workspaceId);
  const workspace =
    member ??
    (page
      ? {
          id: workspaceId,
          name: page.workspace,
          icon: null,
          language: null,
          calendarFeeds: true,
          role: null,
        }
      : undefined);
  return { workspace, loaded: workspaces.isSuccess && (member !== undefined || shared.isFetched) };
}
